import { render, staticRenderFns } from "./PatientDetailsList.vue?vue&type=template&id=08393ddc&scoped=true"
import script from "./PatientDetailsList.vue?vue&type=script&lang=js"
export * from "./PatientDetailsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08393ddc",
  null
  
)

export default component.exports